import { useEffect } from 'react';
import { getHostname } from '../utils/getHostname';

/**
 * Custom hook to set the document title based on the current page
 * @param {string} title - The page title (e.g., "Home", "Contact", "Features")
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    const hostname = getHostname();
    const fullTitle = `${title} - ${hostname}`;
    
    // Update document title
    document.title = fullTitle;
    
    // Also update the title element in the HTML if it exists
    const titleElement = document.getElementById('page-title');
    if (titleElement) {
      titleElement.textContent = fullTitle;
    }
  }, [title]);
}
